import React from 'react';
import CommonLayout from './docking_process'
import ToolsLayout from './docking_process'

export default function Docs() {
  return (
    <CommonLayout tabkey={'docking_process'}>
      <ToolsLayout />
    </CommonLayout>
  )
}
